import { render, staticRenderFns } from "./taskManagerTaskPanel.vue?vue&type=template&id=404c535e&scoped=true&"
import script from "./taskManagerTaskPanel.vue?vue&type=script&lang=js&"
export * from "./taskManagerTaskPanel.vue?vue&type=script&lang=js&"
import style0 from "./taskManagerTaskPanel.vue?vue&type=style&index=0&id=404c535e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404c535e",
  null
  
)

export default component.exports